import { z } from 'zod';
import { FieldSchema } from '../common/field';
import { InitialUIElement } from '../initial-ui-element';
import { CommonOption } from '../common';

export const CHECKBOXLIST_FIELD_ELEMENT_TYPE = 'checkboxlistfield' as const;

export const CheckboxListParamsSchema = FieldSchema.extend({
  options: z.array(CommonOption),
});

export type TCheckboxListParams = z.infer<typeof CheckboxListParamsSchema>;

export const CheckboxListElementType = z.literal(CHECKBOXLIST_FIELD_ELEMENT_TYPE);

export type TCheckboxListElementType = z.infer<typeof CheckboxListElementType>;

export const CheckboxListElementSchema = InitialUIElement.extend({
  element: CheckboxListElementType,
  params: CheckboxListParamsSchema,
  valueDestination: z.string(),
});
